export const FORM_NAME = 'AFTER_SUBMISSION_SIDEBAR_FORM';
